import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Router } from '@angular/router';
import { UsersService } from 'src/app/users/users.service';
import { DeviceService } from 'src/app/home/site-dashboard/device/device.service';
import * as moment from 'moment';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ColumnsConfig, TableConfig, TableData} from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { TranslateService } from '@ngx-translate/core';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { DeviceCommonService } from 'src/app/home/site-dashboard/device/device-common.service';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import { mainDeviceConfig } from 'src/app/home/site-dashboard/device/device-factory/device-config';
import { IotahDevice } from 'src/app/home/site-dashboard/device/device-factory/Iotah-device';
import { DeviceFactory } from 'src/app/home/site-dashboard/device/device-factory/device-factory';
import { DeviceTypeService } from 'src/app/home/site-dashboard/device/device-type.service';

@Component({
	selector: 'app-quick-view-history',
	templateUrl: './quick-view-history.component.html',
	styleUrls: ['./quick-view-history.component.css']
})

export class QuickViewHistoryComponent implements OnInit {
	quickViewHistoryLogs: any[] = [];
	macAddress: string;
	invalidStartDate: boolean = false;
	invalidEndDate: boolean = false;

	fromDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
	toDate: Date = new Date();
	liveRtModalData: any;
	liveEvent: any = {};
	tableData: TableData[] = [];
	tableConfig: TableConfig = {
		hasExport: true,
		hasPagination: true,
		pageSize: 100,
		draggable: true,
		fileName: this.translateService.instant('nav.qv_logs'),
	};

	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		time: TimeSource.Device,
	};

	columnConfig: ColumnsConfig[] = [
		{ key: 'source', name: this.translateService.instant('g.source'), type: 'string', hasFilter: true},
		{ key: 'time', name: this.translateService.instant('g.time'), type: "date", hasFilter: true },
		{ key: 'live_event', name: this.translateService.instant('qv.live_event'), type: "number_link", hasFilter: true },
		{ key: 'ap_status', name: this.translateService.instant('qv.ap_status'), type: "string", hasFilter: true, hidden: true },
		{ key: 'light_sleep_mode', name: this.translateService.instant('qv.sleep_mode'), type: 'boolean', hasFilter: true, hidden: true },
		{ key: 'battery_connected', name: this.translateService.instant('qv.battery_connected'), type: 'boolean', hasFilter: true, hidden: true },
		{ key: 'hw_status', name: this.translateService.instant('qv.hw_status'), type: 'string', hasFilter: true, hidden: true },
		{ key: 'halleffect_c', name: this.translateService.instant('qv.hall_effect'), type: 'number', hasFilter: true},
		{ key: 'ext_adc_voltage', name: this.translateService.instant('qv.voltage_adc'), type: 'number', hasFilter: true},
		{ key: 'ext_adc_current', name: this.translateService.instant('qv.current_adc'), type: 'number', hasFilter: true},
		{ key: 'temperature', name: this.translateService.instant('qv.temperature'), type: 'number', hasFilter: true},
		{ key: 'temperature_adc', name: this.translateService.instant('qv.temperature_adc'), type: 'number', hasFilter: true},
		{ key: 'ext_adc_current_low_range', name: this.translateService.instant('qv.low_current_adc'), type: 'number', hasFilter: true},
		{ key: 'live_rt', name: this.translateService.instant('qv.live_rt'), type: 'number_link', hasFilter: true},
		{ key: 'version', name: this.translateService.instant('g.version'), type: 'number', hasFilter: true, hidden: true},
		{ key: 'rssi', name: this.translateService.instant('qv.rssi'), type: 'number', hasFilter: true, hidden: true},
		{ key: 'network_idx', name: this.translateService.instant('qv.network_idx'), type: 'number', hasFilter: true, hidden: true},
		{ key: 'low_range_is_inuse', name: this.translateService.instant('qv.low_range_is_inuse'), type: 'boolean', hasFilter: true},
		{ key: 'current', name: this.translateService.instant('qv.current'), type: 'number', hasFilter: true},
		{ key: 'voltage', name: this.translateService.instant('qv.voltage'), type: 'number', hasFilter: true},
	];

	@ViewChild("liveRtDetailsModal") liveRtDetailsModal;
	@ViewChild("liveEventModal") liveEventModal;

	device: any = null;
	deviceConfig: mainDeviceConfig | null = (new IotahDevice).config;

	constructor (
		private route: ActivatedRoute,
		private router: Router,
		private userService: UsersService,
		private devicesService: DeviceService,
		private translateService: TranslateService,
		private sctToastService: NotificationMessageService,
		private deviceCommonService: DeviceCommonService,
		private datePipe: DatePipe,
		public common: CommonService,
		public deviceTypeService: DeviceTypeService,
	) {}

	ngOnInit() {
		this.common.applyTimeSourceTooltips(this.columnConfig, this.timeSourceByColumn);

		if (!this.userService.hasAccessPermission(null, 'noc'))
			return this.router.navigate(['/unauthorized']);

		this.route.params.subscribe(params => {
			this.macAddress = params['deviceId'];
			this.common.setPageTabTitle(`${this.translateService.instant('nav.qv_logs')}`);
			this.getQuickViewHistory();
		});
	}

	getQuickViewHistory() {
		this.invalidStartDate = false
		let zoneDiff = new Date().getTimezoneOffset() * -1;

		let from:any = new Date(new Date(this.fromDate).getTime() + (zoneDiff * 60 * 1000));
		let to:any = new Date(new Date(this.toDate).getTime() + (zoneDiff * 60 * 1000));
		from = moment(from).utc().startOf('day').unix();
		to = moment(to).utc().endOf('day').unix();

		if(from > to) {
			this.invalidStartDate = true;
			return this.sctToastService.setMessage('translate|g.start_lg_end');
		}

		this.devicesService.getQuickViewHistory(this.macAddress, from, to).subscribe((response: { device: any, qv_history: any[] }) => {
			this.device = response.device;
			const deviceConfig = DeviceFactory.createDevice(this.device.sct_device_type);
			this.deviceConfig = deviceConfig.config;

			const quickViewHistoryLogs = [];
			[...response.qv_history || []].forEach(quick => {
				const quickData = this.common.decompress(quick.data, 'quick_view');
				let row: TableData = {
					quickData,
					source: {value: this.common.QV_SNAPSHOT_SOURCE[quick.source]},
					time: {value: moment(quickData.time*1000).utc().format('MM/DD/YYYY hh:mm:ss A')},
					live_event: {value: quickData.live_event.sequence_id, action: () => { this.showLiveEventModal(quickData.live_event, quickData) }},
					ap_status: {value: this.deviceCommonService.getApStatus(quickData.ap_status, quickData.ap_ip)},
					light_sleep_mode: {value: !!quickData['light_sleep_mode']},
					battery_connected: {value: !!quickData['battery_connected']},
					hw_status: {value: this.getHwStatus(quickData, 'getHwStatus')},
					halleffect_c: {value: quickData.halleffect_c},
					ext_adc_voltage: {value: quickData.ext_adc_voltage},
					ext_adc_current: {value: quickData.ext_adc_current},
					temperature: {value: quickData.temperature},
					temperature_adc: {value: quickData.temperature_adc},
					ext_adc_current_low_range: {value: quickData.ext_adc_current_low_range},
					live_rt: {value: quickData.live_rt.sequence_id, action: () => {this.showLiveRtModal(quickData.live_rt)}},
					version: {value: quickData.version},
					rssi: {value: quickData.rssi},
					network_idx: {value: quickData.network_idx},
					low_range_is_inuse: {value: !quickData.low_range_is_inuse},
					current: {value: quickData.current},
					voltage: {value: quickData.voltage}

				}
				quickViewHistoryLogs.push(row);
			});

			this.quickViewHistoryLogs = quickViewHistoryLogs;
		});
	}

	showLiveRtModal(liveRt) {
		delete liveRt.isValidCRC16;
		delete liveRt.crc16;

		if (!this.deviceConfig.isBattlink && !this.deviceTypeService.isStudyDevice(this.device))
			delete liveRt.soc;

		liveRt.timestamp = moment(liveRt.timestamp*1000).utc().format('MM/DD/YYYY hh:mm:ss A')
		this.liveRtDetailsModal.show();
		this.liveRtModalData = liveRt;
	}

	readonly noReadingFlagByField: Record<string, string> = {
		min_voltage: 'min_voltage',
		max_voltage: 'min_voltage',
		event_min_current: 'event_min_current',
		event_max_current: 'event_min_current',
	};

	liveEventReading(field: string): string {
		const noReadingFlag = this.noReadingFlagByField[field];

		if (noReadingFlag && DeviceFactory.isIMDeviceType(this.device?.sct_device_type)
			&& this.common.hasNoReading(this.liveEvent[noReadingFlag]))
			return this.common.NO_READING;

		return new DecimalPipe('en-US').transform(this.liveEvent[field], '1.1-3');
	}

	showLiveEventModal(liveEvent, quickData) {
		if (liveEvent.timestamp_utc)
			liveEvent._duration = moment(quickData.time * 1000).utc().diff(moment(liveEvent.timestamp_utc * 1000).utc(), 'seconds');
		else
			liveEvent._duration = moment(quickData.time * 1000).diff(moment(liveEvent.timestamp * 1000).utc(), 'seconds');

		this.liveEvent = liveEvent;

		this.liveEventModal.show();
	}

	formatTime(val, options:any={}) {
		let zoneId = this.liveEvent.my_zone_id;

		if(options.convertToTimestamp)
			val = moment(val).utc().unix();

		let time = this.common.getZoneTimestampFromUTC(zoneId, val);
		time = this.common.getDateFormattedFromUnixTimeStamp(time);

		if(options.timeOnly)
			return this.datePipe.transform(time, 'hh:mm:ss a');

		if(options.dateOnly){
			return this.datePipe.transform(time, 'MM/dd/yyyy');
		}
		return this.datePipe.transform(time, 'MM/dd/yyyy hh:mm:ss a');
	}

	getHwStatus(quick, key) {
		let statuses = {
			2: 'warnings.rtc',
			4: 'warnings.adc',
			8: 'warnings.flash_size',
			16: 'warnings.cellular_chip_hardware_failure'
		};

		let status = [];
		let hwValue = quick[key];

		for(let id in statuses) {
			if((hwValue & +id) != 0) {
				status.push(this.translateService.instant(statuses[id]))
			}
		}
		return status.join(', ');
	}

	formatNotes() {
		var flags = [
			'midnight_split',
			'time_change_split',
			'data_from_bv',
			'split_at_start',
			'split_at_end',
			'flag_finish',
			'flag_eq',
			'flag_finish_start',
			'flag_eq_start',
			'water_level_high',
			'temperature_exists'
		];

		var notes = [];

		flags.forEach((key) => {
			if(this.liveEvent[key])
				notes.push(this.translateService.instant('event.'+key));
		});

		return notes.join(', ');
	}

	formatQv(key, type="any", options={}) {
		let booleans = {
			'event': ['isValidCRC16'],
			'any': ['light_sleep_mode', 'low_range_is_inuse', 'battery_connected']
		};

		switch (type) {
			case "event":
				switch(key) {
					case "event_type":
						if(this.devicesService.eventTypes[this.liveEvent.event_type] !== undefined)
							return this.translateService.instant('event.'+this.devicesService.eventTypes[this.liveEvent.event_type]);
					break;
					case "finish_reason":
						if(this.devicesService.finishReasons[this.liveEvent[key]] !== undefined)
							return this.translateService.instant('event.'+this.devicesService.finishReasons[this.liveEvent[key]]);
					break;
					case "eq_reason":
						if(this.devicesService.eqReasons[this.liveEvent[key]] !== undefined)
							return this.translateService.instant('event.'+this.devicesService.eqReasons[this.liveEvent[key]]);
					break;
					case "my_zone_id":
						let zoneId = this.liveEvent[key];
						return this.common.getZoneName(zoneId) + ' ['+zoneId+']';
					break;
					case "water_level_high":
						let waterLevel = this.liveEvent[key] ? 'high' : 'low';
						return this.translateService.instant('g.'+waterLevel);
					break;
					case "timestamp_utc":
					case "end_timestamp_utc":
						return this.formatTime(this.liveEvent[key], options);
					break;
					case "notes":
						return this.formatNotes();
					break;
					default:
						if(booleans['event'].includes(key))
							return !!this.liveEvent[key];
					break;
				}
			break;

			default:
				switch(key) {
					case "time":
						return this.formatTime(this.liveEvent[key]);
					break;
					default:
						if(booleans['any'].includes(key))
							return !!this.liveEvent[key];
					break;
				}
			break;
		}
	}
}
